'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface TopologyControlsProps {
  zoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
}

export default function TopologyControls({ zoom, onZoomIn, onZoomOut, onReset }: TopologyControlsProps) {
  return (
    <div className="flex flex-col gap-1 bg-surface border border-border rounded-xl p-1 shadow-xl">
      <button
        onClick={onZoomIn}
        disabled={zoom >= 2.5}
        title="Ingrandisci"
        className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-surface-elevated disabled:opacity-30 disabled:cursor-not-allowed transition-all text-secondary-color hover:text-white"
      >
        <Icon name="PlusIcon" size={18} />
      </button>
      <div className="px-1 py-0.5 text-center">
        <span className="text-xs font-mono text-muted-color tabular-nums">
          {Math.round(zoom * 100)}%
        </span>
      </div>
      <button
        onClick={onZoomOut}
        disabled={zoom <= 0.3}
        title="Riduci"
        className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-surface-elevated disabled:opacity-30 disabled:cursor-not-allowed transition-all text-secondary-color hover:text-white"
      >
        <Icon name="MinusIcon" size={18} />
      </button>
      <div className="border-t border-border my-0.5" />
      <button
        onClick={onReset}
        title="Reimposta vista"
        className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-surface-elevated transition-all text-secondary-color hover:text-white"
      >
        <Icon name="ArrowsPointingInIcon" size={17} />
      </button>
    </div>
  );
}